<section
  class="d-flex flex-1"
  [ngStyle]="bannerImage"
  [ngClass]="
    bannerClasses + ` ${isMobile() ? 'fullwidth-section-mobile' : 'fullwidth-section' + ` ${bannerSize === 'contain' ? 'contain-render-before' : ''}` }`
  "
>
  <div class="d-flex flex-1 banner-layout w-100" [ngClass]="bannerClasses">
    <div class="app-container container-xl container-xl-max-md d-flex">
      <ng-content></ng-content>
    </div>
  </div>
</section>
